export const IconPlay = ({ className }: { className?: string }) => (
  <svg
    aria-hidden="true"
    className={className ?? 'color-primary'}
    fill="currentColor"
    height="16"
    viewBox="0 0 20 20"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.3 2.841A1.5 1.5 0 004 4.11v11.78a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
  </svg>
);
